import React from "react";
import PropTypes from "prop-types";
import { defaultTemplate } from "core/hoc";
import {
    BaasicTable,
    TableFilter,
    EmptyState,
    BaasicModal,
    BaasicButton,
    QueryDropdown,
    BasicQueryCheckbox
} from "core/components";
import { PatientAddModal, FacilityOrderExtraSuppliesAddModal, TaskNotesModal, EditFacilityOrderTemplateInactiveReasonModal } from "application/facility-order/components";
import { FacilityInventoryCountEdit } from 'application/facility-inventory/components';
import { ApplicationListLayout, Content, PageNavigation } from "core/layouts";
import { FacilityOrderTemplatePreview } from "application/facility-order/pages";
import { DropDownButton, DropDownButtonItem } from "@progress/kendo-react-buttons";
import { isSome } from 'core/utils';

const FacilityOrderTemplateListTemplate = function ({ t, facilityOrderTemplateListViewStore }) {

    const {
        tableStore,
        routes,
        queryUtility,
        authorization,
        oldDownloadUrl,
        downloadUrl,
        downloadInventoryUrl,
        previewModal,
        isPickTicketCreated,
        createPickTicket,
        refreshPickTicket,
        convertFacilityInventoryCountDetails,
        importFacilityOrder,
        isInventoryCreated,
        createInventory,
        noFacilityOrderTemplates,
        isImportEnabled,
        isPartBOnly,
        patientAddModal,
        openPatientAddModal,
        editFacilityOrderTemplateInactiveReasonModal,
        itemCategoryStore,
        inactiveQueryCheckboxStore,
        nonCurrentQueryCheckboxStore,
        taskNotesModal,
        showTaskNotes,
        extraSuppliesAddModal,
        openExtraSuppliesAddModal,
        isPickTicketHeaderInProgres,
        isPickTicketHeaderCompleted,
        isSendOrder,
        openAdjustNextRunDates,
        facilityInventoryCountEditModal,
        openFacilityInventoryCountEditModal
    } = facilityOrderTemplateListViewStore;

    const handleDropDownItemsOnClick = (e) => {
        if (e.item.text === "Import") {
            importFacilityOrder();
        }
        else if (e.item.text === "Add Existing Patient") {
            openPatientAddModal();
        }
        else if (e.item.text === "Add Inventory") {
            openFacilityInventoryCountEditModal();
        }
        else if (e.item.text === "Edit Inventory"){
            createInventory();
        }
        else if (e.item.text === "Inventory Calculation") {
            convertFacilityInventoryCountDetails();
        }
        else if (e.item.text === "Pick Ticket" && !isPickTicketCreated) {
            createPickTicket();
        }
        else if (e.item.text === "Pick Ticket" && isPickTicketCreated) {
            refreshPickTicket();
        }
        else if (e.item.text === "Overview") {
            routes.insuranceCoverageStatusOverviewEmailEdit();
        }
        else if (e.item.text === "Documentation Request") {
            routes.documentationRequestEmailEdit();
        }
        else if (e.item.text === "Download Inventory") {
            window.open(downloadInventoryUrl, "_blank");
        }
        else if (e.item.text === "Old Download") {
            window.open(oldDownloadUrl, "_blank");
        }
        else if (e.item.text === "Download") {
            window.open(downloadUrl, "_blank");
        }
        else if(e.item.text === "Add Extra Supplies"){
            openExtraSuppliesAddModal();
        }
        else if(e.item.text === "Adjust Next Run Dates"){
            openAdjustNextRunDates();
        }
    }
    return (
        <React.Fragment>
            {   (isPickTicketHeaderInProgres || isPickTicketHeaderCompleted || isSendOrder) && 
                <React.Fragment>
                    <div style={{height: "12px"}}></div>
                    <div style={{ lineHeight:"2", top: "0", left: "0", width: "100%", position: "absolute", backgroundColor: "rgba(255, 0, 0, 0.7)", marginLeft: "0px", marginRight: "0px"}} className="row">
                        <spam style={{width: "100%", color: "white"}} className="type--center"> { isPickTicketHeaderInProgres ? "Purchasing is in progress. Don't make changes to the facility order." : isPickTicketHeaderCompleted ? "Purchasing is complete. Don't make changes to the facility order" : "Billing is in Progress, any changes made must be reported to the biller."} </spam>
                    </div>
                </React.Fragment>
            }
            <ApplicationListLayout
                store={facilityOrderTemplateListViewStore}
                authorization={authorization}
            >
                <PageNavigation>
                <BaasicButton authorized={authorization.create} className="btn btn--base btn--primary" label={'Task notes'} onClick={() => showTaskNotes()} ></BaasicButton>               
                <BaasicButton authorized={authorization.create} className="btn btn--base btn--primary" label={'Create New Patient'} icon="u-icon u-icon--xsml u-icon--add--white" onClick={() => routes.createPatient()} ></BaasicButton>               
                <DropDownButton buttonClass="btn btn--base btn--primary"
                                disabled={ false }
                                className = "btn"
                                text="Actions"
                                size={"medium"}
                                themeColor={"primary"}
                                fillMode={"solid"}
                                popupSettings={{
                                    animate: false,
                                    anchorAlign: {horizontal: "right", vertical:"bottom"},
                                    popupAlign: {horizontal: "right", vertical:"top"}
                                    }}
                                onItemClick={(e) => handleDropDownItemsOnClick(e)}
                            >
                                <DropDownButtonItem text="Import" iconClass="u-icon u-icon--sml u-icon--upload--grey u-mar--right--tny" disabled={!isImportEnabled}/>
                                {oldDownloadUrl && <DropDownButtonItem text="Old Download" iconClass="u-icon u-icon--sml u-icon--download u-mar--right--tny" style={{border:"1px"}}/>}
                                {downloadUrl && <DropDownButtonItem text="Download" iconClass="u-icon u-icon--sml u-icon--download u-mar--right--tny" style={{border:"1px"}}/>}
                                <DropDownButtonItem text="Add Extra Supplies" iconClass="u-icon u-icon--sml u-icon--add--grey u-mar--right--tny" style={{border:"1px"}}/>
                                <DropDownButtonItem text="Adjust Next Run Dates" iconClass="u-icon u-icon--sml u-icon--edit u-mar--right--tny" style={{border:"1px"}}/>
                                <DropDownButtonItem render={()=>{return <Temp/>}} selected={null}/>
                                {/* <DropDownButtonItem text="Add Existing Patient" iconClass="u-icon u-icon--sml u-icon--add--grey u-mar--right--tny"/>
                                <DropDownButtonItem render={()=>{return <Temp/>}} selected={null}/> */}
                                {!isPartBOnly && <DropDownButtonItem text={`${isInventoryCreated ? "Edit Inventory" : "Add Inventory"}`} iconClass={`${isInventoryCreated ? "u-icon u-icon--sml u-icon--edit u-mar--right--tny" : "u-icon u-icon--sml u-icon--add--grey u-mar--right--tny"}`}/>}
                                {!isPartBOnly && <DropDownButtonItem text="Inventory Calculation" disabled={!isInventoryCreated} iconClass="u-icon u-icon--sml u-icon--calculation u-mar--right--tny" />}
                                {/* {downloadInventoryUrl && <DropDownButtonItem text="Download Inventory" iconClass="u-icon u-icon--sml u-icon--download u-mar--right--tny"></DropDownButtonItem>} */}
                                {!isPartBOnly && <DropDownButtonItem render={()=>{return <Temp/>}} selected={null}/>}
                                {!isPickTicketCreated && <DropDownButtonItem text="Pick Ticket" disabled={noFacilityOrderTemplates} iconClass="u-icon u-icon--sml u-icon--add--grey u-mar--right--tny"/>}
                                {isPickTicketCreated && <DropDownButtonItem text="Pick Ticket" disabled={noFacilityOrderTemplates} iconClass="u-icon u-icon--sml u-icon--edit u-mar--right--tny"/>}
                                <DropDownButtonItem text="Overview" iconClass="u-icon u-icon--sml u-icon--envelope--grey u-mar--right--tny"/>
                                <DropDownButtonItem text="Documentation Request" iconClass="u-icon u-icon--sml u-icon--envelope--grey u-mar--right--tny"/>
                </DropDownButton>

                </PageNavigation>
                <Content emptyRenderer={renderEmpty(routes)}>
                    <div className="u-mar--bottom--sml">
                        <TableFilter queryUtility={queryUtility} filterVisible={true} showFilterButtons={false}>
                            <div className="col col-sml-12 col-med-6 col-lrg-4 col-xxlrg-3 form__group">
                                <QueryDropdown id={'categories'} queryUtility={queryUtility} propertyName={'itemCategoryIds'} label={'Category'} store={itemCategoryStore} clearable={false} />
                            </div>
                            <div className="col form__group u-flex--self--center">
                                <div className="u-flex--primary">
                                    <div className="u-mar--right--sml">
                                        <BasicQueryCheckbox id={'inActive'} queryUtility={queryUtility} propertyName={'inActive'} label={'Show Inactive'} store={inactiveQueryCheckboxStore}/>
                                    </div>
                                    <div>
                                        <BasicQueryCheckbox id={'nonCurrent'} queryUtility={queryUtility} propertyName={'nonCurrent'} label={'Show Non-current'} store={nonCurrentQueryCheckboxStore}/>
                                    </div>
                                </div>
                            </div>
                            <div className="col col-sml-12 col-med-6 col-lrg-4 col-xxlrg-2 form__group hide--on-print u-flex--self--center">
                                    <button
                                        className='btn btn--base btn--primary u-mar--right--tny'
                                        onClick={() => queryUtility.fetch()}
                                    >
                                        <span>{t('GRID.FILTER.SEARCH_BUTTON')}</span>
                                    </button>
                                    <button
                                        className='btn btn--base btn--ghost'
                                        onClick={() => queryUtility.resetFilter()}
                                    >
                                        {t('GRID.FILTER.CLEAR_BUTTON')}
                                    </button>
                                </div>
                        </TableFilter>
                    </div>
                    <div className="card--table">
                        <BaasicTable
                            authorization={authorization}
                            tableStore={tableStore}
                            actionsComponent={renderActions}
                        />
                    </div>
                </Content>
                <BaasicModal className="ReactModal__Content--screen-to-lrg ReactModal__Content--screen-from-xxlrg--large ReactModal__Content--screen-to-xxlrg--large modal__content" modalParams={previewModal}>
                    <FacilityOrderTemplatePreview />
                </BaasicModal>
                <BaasicModal modalParams={patientAddModal}>
                    <PatientAddModal />
                </BaasicModal>
                <BaasicModal modalParams={extraSuppliesAddModal} className="modal__content modal--sml">
                    <FacilityOrderExtraSuppliesAddModal />
                </BaasicModal>
                <BaasicModal modalParams={taskNotesModal} className="modal__content modal--med">
                    <TaskNotesModal />
                </BaasicModal>
                <BaasicModal modalParams={editFacilityOrderTemplateInactiveReasonModal}>
                    <EditFacilityOrderTemplateInactiveReasonModal />
                </BaasicModal>
                <BaasicModal modalParams={facilityInventoryCountEditModal} className="modal__content modal--sml">
                    <FacilityInventoryCountEdit />
                </BaasicModal>
            </ApplicationListLayout>
        </React.Fragment>
    );
};

const Temp = () => {
    return <div className="u-separator--primary w--100"/>
};

function renderEmpty(routes) {
    return (
        <EmptyState
            title="FACILITY_ORDER_TEMPLATE.LIST.EMPTY_STATE.TITLE"
            callToAction={routes.create}
        />
    );
}

FacilityOrderTemplateListTemplate.propTypes = {
    facilityOrderTemplateListViewStore: PropTypes.object.isRequired,
    t: PropTypes.func
};

function renderActions({ item, actions, authorization }) {
    if (!isSome(actions)) return null;

    const { onEdit} = actions;
    if (!isSome(onEdit)) return null;

    return (
        <td className="table__body--data right">
            <div className="table__icons">               
                <BaasicButton
                    authorization={authorization ? authorization.update : null}
                    className="btn btn--icon"
                    icon='u-icon u-icon--edit u-icon--sml'
                    label='FACILITY_ORDER_TEMPLATE.LIST.ACTIONS.EDIT_INACTIVE_REASON'
                    onlyIcon={true}
                    onClick={() => onEdit(item) }>
                </BaasicButton>
            </div>
        </td>
    )
}

renderActions.propTypes = {
    item: PropTypes.object,
    actions: PropTypes.any,
    authorization: PropTypes.any
};

export default defaultTemplate(FacilityOrderTemplateListTemplate);